module.exports = __webpack_public_path__ + "static/img/1.1db4c665.png";